<div class="dashboard-detail flex-col" #wrapper>
  <div class="flex-col gap-8 actions">
    <div class="flex-row start-center gap-8 filters">
      <div class="flex-row space-between-center ui-selector filter-selector" (click)="selectCamera()">
        <span>{{ selectedCameras?.length ? ('DASHBOARD_VIEW.SELECTED_CAMERAS'|translate:{ count: selectedCameras.length }) : 'DASHBOARD_VIEW.CAMERAS'|translate }}</span>
      </div>
      <ui-tracker-class-selector class="flex" [(ngModel)]="trackerOptions"
                                 (ngModelChange)="changeTracker()"
                                 [ngModelOptions]="{standalone: true}"
      ></ui-tracker-class-selector>
      <div class="date-time-range-picker-wrapper">
        <ui-calendar
          [inputStyle]="inputStyles.noLabel"
          [inputConfig]="{truncateText: true}"
          [selectDateRange]="dateRange"
          [maxRetentionDays]="maxRetentionDays()"
          [hoursFormat]="hoursFormat()"
          (rangeSelected)="changeDateRange($event)"
        ></ui-calendar>
        <div class="picker-tz">{{ userTimezoneAbbreviation() }}</div>
      </div>
      <span class="ui-icon-cross ui-icon-button no-border"
            (click)="resetFilters()"
            [matTooltip]="'DASHBOARD_VIEW.TOOLTIPS.RESET_FILTERS'|translate"
      ></span>
      <span class="ui-icon-pin ui-icon-button no-border primary"
            (click)="saveFilters()"
            [matTooltip]="'DASHBOARD_VIEW.TOOLTIPS.SAVE_FILTERS'|translate"
      ></span>
    </div>
    <div class="flex-row space-between-center gap-8 controls">
      <div class="view-toggle" *ngIf="hasWidgets">
        <button
          type="button"
          class="view-toggle-btn"
          [class.active]="viewMode() === DetailViewMode.Grid"
          [matTooltip]="'DASHBOARDS_RESULT.GRID_VIEW' | translate"
          (click)="setViewMode(DetailViewMode.Grid)"
        >
          <span class="ui-icon-wall-sidebar"></span>
        </button>
        <button
          type="button"
          class="view-toggle-btn"
          [class.active]="viewMode() === DetailViewMode.Layout"
          [matTooltip]="'DASHBOARDS_RESULT.LAYOUT_VIEW' | translate"
          (click)="setViewMode(DetailViewMode.Layout)"
        >
          <span class="ui-icon-dashboards-sidebar"></span>
        </button>
      </div>
      <div class="flex-row start-center gap-8">
        <ui-preloader *ngIf="widgetsLoading"
                      class="widgets-loading-spinner"
                      [color]="PreloaderColor.blue"
                      [diameter]="20"
                      [matTooltip]="'DASHBOARDS_RESULT.LOADING_WIDGETS' | translate"
        ></ui-preloader>
        <ui-toggle
          [matTooltip]="autoRefreshEnabled ? ('DASHBOARD_VIEW.TOOLTIPS.DISABLE_AUTO_REFRESH'|translate): ('DASHBOARD_VIEW.TOOLTIPS.ENABLE_AUTO_REFRESH'|translate)"
          [(ngModel)]="autoRefreshEnabled"
          (ngModelChange)="configureAutoRefresh()"
          (click)="$event.stopPropagation();"
        ></ui-toggle>
        <mat-select
          [(ngModel)]="autoRefreshInSec"
          (ngModelChange)="configureAutoRefresh()"
          class="ui-selector interval-selector"
        >
          <mat-option [value]="30">{{ 'DASHBOARD_VIEW.INTERVAL.30SECONDS'|translate }}</mat-option>
          <mat-option [value]="60">{{ 'DASHBOARD_VIEW.INTERVAL.1MINUTE'|translate }}</mat-option>
          <mat-option [value]="300">{{ 'DASHBOARD_VIEW.INTERVAL.5MINUTES'|translate }}</mat-option>
          <mat-option [value]="900">{{ 'DASHBOARD_VIEW.INTERVAL.15MINUTES'|translate }}</mat-option>
          <mat-option [value]="1800">{{ 'DASHBOARD_VIEW.INTERVAL.30MINUTES'|translate }}</mat-option>
        </mat-select>
        <div *ngIf="autoRefreshEnabled" class="flex-row center-center countdown">
          {{ remainingTimeDisplay }}
        </div>
        <ui-button
          iconClass="ui-icon-forward"
          type="default"
          [matTooltip]="'DASHBOARD_VIEW.TOOLTIPS.REFRESH_DATA'|translate"
          (clickAction)="refresh()"
        ></ui-button>
        <ui-button
          iconClass="ui-icon-fullscreen-2"
          type="default"
          [matTooltip]="'COMMON.FULLSCREEN'|translate"
          (clickAction)="maximize()"
        ></ui-button>
      </div>
    </div>
  </div>

  <div class="layout-container" *ngIf="hasWidgets; else empty">
    <app-dashboard-layout *ngIf="viewMode() === DetailViewMode.Layout"
                          class="h-100"
                          [existing]="dashboard.layout"
                          [edit]="false"
    ></app-dashboard-layout>

    <div class="widget-grid" *ngIf="viewMode() === DetailViewMode.Grid">
      <div class="widget-cell" *ngFor="let item of dashboard.layout">
        <ui-widget [info]="item.widgetInfo"></ui-widget>
      </div>
    </div>
  </div>

  <ng-template #empty>
    <div class="empty-state">{{ 'DASHBOARDS_RESULT.NO_WIDGETS' | translate }}</div>
  </ng-template>
</div>
